import _ from "lodash"
import { v4 as uuidv4 } from "uuid"
import { initDb, initFunctions } from "../tools/conf"
import { welfareAnalyser } from "./wellfareStats"

let wStats = new welfareAnalyser()

export class SurveyDatabaseConnector {
  getCategoryFromText(categoryText, text, option) {
    switch (categoryText) {
      case "Hébergement":
        return 1
      case "Alimentation":
        return 2
      case "Santé":
        return 3
      case "Comportement":
        return 4
      default:
        throw new Error(`Le questionnaire comprend une question de categorie inconnue : ${text} / ${option}`)
    }
  }

  getQuestionTypeFromLabel(typeText, text, option) {
    switch (typeText) {
      case "Question choix multiple":
        return { value: "multi", label: "Question choix multiple" }
      case "Question simple":
        return { value: "simple", label: "Question simple" }
      case "Question choix multiple - Informative":
        return { value: "multiInfo", label: "Question choix multiple - Informative" }
      case "Question simple - Informative":
        return { value: "simpleInfo", label: "Question simple - Informative" }
      case "Libre":
        return { value: "libre", label: "Libre" }
      default:
        throw new Error(`Le questionnaire comprend une question de type inconnu : ${text} / ${option}`)
    }
  }

  getQuestionPointsObject(value, questionText) {
    switch (value) {
      case "Ne sais pas":
        return {
          label: `Ne sais pas`,
          nullReason: "NC",
          value: null,
        }
      case "Non applicable":
        return {
          label: `Non applicable`,
          nullReason: "NA",
          value: null,
        }
      default:
        let val = parseInt(value)
        if (isNaN(val)) {
          throw new Error(`Echec de l'importation - Absence de point sur l'option : ${questionText} `)
        } else {
          return {
            label: value,
            nullReason: "NC",
            value: parseInt(value),
          }
        }
    }
  }

  parseCoef(coef, questionText) {
    if (coef === undefined) {
      throw new Error(`Echec de l'importation - Erreur de coef sur la question : ${questionText} `)
    }

    if (coef !== "null") {
      let floatCoef = parseFloat(coef.replace(",", "."))
      if (isNaN(floatCoef)) {
        throw new Error(`Echec de l'importation - Erreur de coef sur la question : ${questionText} `)
      } else {
        return floatCoef
      }
    } else {
      return null
    }
  }

  _parseImportedCsvFile(jsonSurveyfromCsv) {
    let surveyArray = []

    console.log("jsonSurveyfromCsv[0]")
    console.log(jsonSurveyfromCsv[0])
    console.log("jsonSurveyfromCsv[1]")
    console.log(jsonSurveyfromCsv[1])

    console.log("jsonSurveyfromCsv.length")

    let length = jsonSurveyfromCsv.length
    console.log(length)
    console.log("jsonSurveyfromCsv[jsonSurveyfromCsv.length]")
    console.log(jsonSurveyfromCsv[length - 1])

    jsonSurveyfromCsv.forEach((option, index) => {
      // new question
      if (index !== 0) {
        let foundIndex = surveyArray.findIndex((existingQuestion) => existingQuestion.questionText === option.data[1])
        if (foundIndex === -1) {
          // initialisation d'une nouvelle question
          let uid = uuidv4()

          let optionNewEntry = {
            optionText: option.data[3],
            optionPoints: this.getQuestionPointsObject(option.data[4], option.data[3]),
            optionIsFatal: option.data[5] === "true" || option.data[5] === "TRUE" || option.data[5] === "VRAI" ? true : false,
            optionFatalMessage: option.data[5] === "true" || option.data[5] === "TRUE" || option.data[5] === "VRAI" ? option.data[6] : null,
            optionForcingSingleAnswer: option.data[11] === "true" || option.data[11] === "TRUE" || option.data[11] === "VRAI" ? true : false,
          }

          let newEntry = {
            questionId: uid,
            category: this.getCategoryFromText(option.data[0], option.data[1], optionNewEntry.optionText),
            questionText: option.data[1],
            questionCoef: this.parseCoef(option.data[10], option.data[1]),
            questionType: this.getQuestionTypeFromLabel(option.data[2], option.data[1], optionNewEntry.optionText),
            questionOptions: [optionNewEntry],
            applyForIndoor: option.data[7] === "true" || option.data[7] === "TRUE" || option.data[7] === "VRAI" ? true : false,
            applyForOutdoor: option.data[8] === "true" || option.data[8] === "TRUE" || option.data[8] === "VRAI" ? true : false,
            isPeriodical: option.data[9] === "true" || option.data[9] === "TRUE" || option.data[9] === "VRAI" ? true : false,
          }
          surveyArray.push(newEntry)
        } else {
          // ajout d'une nouvelle réponse à une question existante
          let optionNewEntry = {
            optionText: option.data[3],
            optionPoints: this.getQuestionPointsObject(option.data[4], option.data[3]),
            optionIsFatal: option.data[5] === "true" || option.data[5] === "TRUE" || option.data[5] === "VRAI" ? true : false,
            optionFatalMessage: option.data[5] === "true" || option.data[5] === "TRUE" || option.data[5] === "VRAI" ? option.data[6] : null,
            optionForcingSingleAnswer: option.data[11] === "true" || option.data[11] === "TRUE" || option.data[11] === "VRAI" ? true : false,
          }
          surveyArray[foundIndex].questionOptions.push(optionNewEntry)
        }
      }
    })
    return surveyArray
  }

  _sortQuestionInOrder(surveyData) {
    let surveyQuestions = surveyData.quizzQuestions
    let tableQuestionIndex = surveyData.tableQuestionIndex

    if (surveyQuestions.length === tableQuestionIndex.length) {
      let sortedQuizz = []
      for (let i = 0; i < tableQuestionIndex.length; i++) {
        let el = tableQuestionIndex.find((question) => question.position === i)
        let question = surveyQuestions.find((question) => question.questionId === el.questionId)
        sortedQuizz.push(question)
      }
      return sortedQuizz
    } else {
      return surveyQuestions
    }
  }

  async _getSurveyListFilterdWithId(zooId) {
    let db = await initDb()
    let snapshot = await db.collection("survey").get()
    let list = []
    snapshot.forEach((doc) => {
      let data = doc.data()
      if (_.has(data, "zooAvailability")) {
        let index = data.zooAvailability.findIndex((el) => el.value === zooId)
        if (index >= 0) {
          list.push(doc.data())
        }
      }
    })
    return list
  }

  async _getSurveyListFilteredByZoo(zooId) {
    try {
      let db = initDb()
      let snapshot = await db.collection("survey").where("zooAvailabilityArray", "array-contains", zooId).get()
      let list = []
      snapshot.forEach((doc) => {
        list.push(doc.data())
      })
      return list
    } catch (error) {
      console.log("error")
      console.log(error)
    }
  }

  async _getSurveyList() {
    try {
      let db = initDb()
      let snapshot = await db.collection("survey").get()
      let list = []
      snapshot.forEach((doc) => {
        list.push(doc.data())
      })
      return list
    } catch (error) {
      console.log("error")
      console.log(error)
    }
  }

  formatQuizz(survey) {
    console.log("format quizz")
    let surveyArray = []
    if (_.has(survey, "quizzQuestions")) {
      for (let item of survey.quizzQuestions) {
        surveyArray.push(item)
      }
    } else {
      survey.quizzQuestions = []
    }
    return survey
  }

  async _getSurveyFromId(id) {
    try {
      let db = initDb()
      let snapshot = await db.collection("surveys").doc(id).get()
      let surveyData = snapshot.data()

      if (_.has(surveyData, "tableQuestionIndex")) {
        surveyData.quizzQuestions = this._sortQuestionInOrder(surveyData)
      }

      return surveyData
    } catch (error) {
      return null
    }
  }

  async _getSurveyFromIdWithoutFormatting(id) {
    let db = initDb()
    try {
      let res = await db.ref("global/surveys/" + id).once("value")
      return {
        success: true,
        data: res.val(),
      }
    } catch (error) {
      return {
        success: false,
        data: error,
      }
    }
  }

  async _getActiveCampaignFromSurvyeId(surveyId) {
    let db = await initDb()
    let snapshot = await db.collection("campaigns").where("surveyId", "==", surveyId).get()
    let activeCampaign = []
    snapshot.forEach((doc) => {
      let campaign = doc.data()
      activeCampaign.push({
        campaignName: campaign.campaignName,
        campaignId: campaign.campaignId,
        zooName: campaign.zooName,
      })
    })
    return activeCampaign
  }

  async _deleteQuizz(quizzId) {
    let db = initDb()
    try {
      await db.collection("survey").doc(quizzId).delete()
      return { success: true }
    } catch (error) {
      return { success: false, data: error }
    }
  }

  async _setNewQuizzV2(quizzData) {
    let db = initDb()
    let id = uuidv4()
    let newEntry = {
      ...quizzData,
      surveyId: id,
      quizzId: id,
      value: id,
      label: quizzData.quizzName,
      surveyType: "V2",
      quizzVersion: 1,
    }

    let quizzQuestions = quizzData.quizzQuestions

    delete newEntry.quizzQuestions

    try {
      await db.collection("surveys").doc(id).set(newEntry)
      await Promise.all(
        quizzQuestions.map(async (question) => {
          await db.collection("surveys").doc(id).collection("questions").doc(question.questionId).set(question)
        })
      )
      return { success: true, data: newEntry }
    } catch (error) {
      return { success: false, data: error }
    }
  }

  async _setNewQuizz(quizzData) {
    let db = initDb()
    let id = uuidv4()
    let newEntry = {
      ...quizzData,
      surveyId: id,
      quizzId: id,
      value: id,
      label: quizzData.quizzName,
      quizzVersion: 1,
    }

    let stats = await wStats._getWellfareOverviewFromQuizz(newEntry)

    newEntry = {
      ...newEntry,
      ...stats,
    }

    try {
      let res = await db.collection("survey").doc(id).set(newEntry)
      console.log("res")
      console.log(res)

      return { success: true, data: newEntry }
    } catch (error) {
      return { success: false, data: error }
    }
  }

  async _pushQuizzToProd(quizzData) {
    let stats = await wStats._getWellfareOverviewFromQuizz(quizzData)
    let id = uuidv4()
    let newEntry = {
      ...quizzData,
      ...stats,
      label: `${quizzData.quizzName} - importé`,
      quizzName: `${quizzData.quizzName} - importé`,
      quizzVersion: 1,
      zooAvailability: [],
      zooAvailabilityArray: [],
      quizzId: id,
      surveyId: id,
      quizzSpecie: [],
    }

    delete newEntry.value

    let url = "https://europe-west3-aws-prod-3fac0.cloudfunctions.net/pushQuizzToProd"
    //let url = "https://europe-west3-aws-dev-606fa.cloudfunctions.net/pushQuizzToProd"

    try {
      let res = await fetch(url, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        method: "POST",
        body: JSON.stringify({ quizzData: newEntry }),
      })
      console.log(res)
      //
      // await db.collection("survey").doc(newEntry.surveyId).update(newEntry)
      return { success: true, data: null }
    } catch (error) {
      console.log("error")
      console.log(error)
      return { success: false, data: error }
    }
  }

  async _updateQuizz(quizzData) {
    let stats = await wStats._getWellfareOverviewFromQuizz(quizzData)
    let db = initDb()
    let newEntry = {
      ...quizzData,
      ...stats,
      label: quizzData.quizzName,
      quizzVersion: quizzData.quizzVersion + 1,
    }

    try {
      await db.collection("survey").doc(newEntry.surveyId).update(newEntry)
      return { success: true, data: newEntry }
    } catch (error) {
      console.log("error")
      console.log(error)
      return { success: false, data: error }
    }
  }

  async getSurveyStats(data) {
    return
  }

  async _getQuizzAlertAmount(quizz) {
    let alertAmount = 0
    for (let response of quizz.answers) {
      if (response.answers !== false) {
        response.answers.forEach((item) => {
          if (item.optionIsFatal === true) {
            alertAmount = alertAmount + 1
          }
        })
      }
    }
    return alertAmount
  }

  async _getUpdatedScore(answers, surveyId, quizzId) {
    try {
      const cloud = await initFunctions()
      const getUpdatedScore = cloud.httpsCallable("getUpdatedScore")
      const res = await getUpdatedScore(quizzId ? { quizzId, surveyId } : { answers, surveyId })
      return res.data?.success === true
        ? { success: true, data: res.data.data }
        : { success: false }
    } catch (error) {
      return { success: false, code: error.code }
    }
  }

  async _pushUpdatedScoreToDatabase(newScores, quizzId) {
    let db = await initDb()
    try {
      await db.collection("quizz").doc(quizzId).update({
        quizzStats: newScores,
      })
      return { success: true }
    } catch (error) {
      console.log("error")
      console.log(error)
      return { success: false }
    }
  }

  async getSurveyContainingQuestion(questionId) {}

  async _getCampaignQuestionFromId(questionId, campaignId) {
    let db = await initDb()
    let snapshot = await db.collection("campaigns").doc(campaignId).collection("survey").doc("surveyData").collection("questions").doc(questionId).get()
    return snapshot.data()
  }

  async _getSurveyFromPipeline(pipeline) {
    return 0
  }
}
